<template>
  <div class="config-page">
    <a-card :bordered="false">
      <div class="config-layout">
        <!-- 右侧内容区 -->
        <div class="main-content">
          <a-tabs v-model:activeKey="activeTab">
            <a-tab-pane key="system" tab="系统配置">
              <div class="config-content-wrapper">
                <!-- 左侧表单 -->
                <div class="config-form-left">
                  <a-form :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
                    <a-form-item label="注册分配的角色">
                      <a-select v-model:value="formState.assignedRole" style="width: 320px">
                        <a-select-option value="user">普通用户</a-select-option>
                        <!-- 其他角色选项 -->
                      </a-select>
                    </a-form-item>
                    <a-form-item label="和风天气秘钥">
                      <a-input v-model:value="formState.weatherApiKey" placeholder="请输入秘钥" style="width: 320px" />
                      <!-- 可能需要一个旁边的图标或提示 -->
                    </a-form-item>
                    <a-form-item label="问题反馈通知用户">
                      <!-- 使用 a-select mode="tags" 可能更符合图片效果 -->
                      <a-input v-model:value="formState.feedbackNotifyUser" placeholder="请输入用户名" style="width: 320px" />
                    </a-form-item>
                    <a-form-item label="是否检查用户注销">
                      <a-radio-group v-model:value="formState.checkUserLogout">
                        <a-radio value="disallow">禁止项目管理员注销账号</a-radio>
                        <a-radio value="allow">允许项目管理员注销账号</a-radio>
                      </a-radio-group>
                    </a-form-item>
                    <a-form-item label="启用单点会话登录">
                      <a-radio-group v-model:value="formState.enableSSO">
                        <a-radio value="enable">启用</a-radio>
                        <a-radio value="disable">禁用</a-radio>
                      </a-radio-group>
                    </a-form-item>
                    <a-form-item label="操作日志保留时间">
                      <a-radio-group v-model:value="formState.opLogRetention">
                        <a-radio value="permanent">永久</a-radio>
                        <a-radio value="custom">自定义</a-radio>
                      </a-radio-group>
                    </a-form-item>
                    <a-form-item label="登陆日志保留时间">
                      <a-radio-group v-model:value="formState.loginLogRetention">
                        <a-radio value="permanent">永久</a-radio>
                        <a-radio value="custom">自定义</a-radio>
                      </a-radio-group>
                    </a-form-item>
                    <a-form-item :wrapper-col="{ offset: 8 }">
                      <a-button type="primary" @click="saveConfig">保存</a-button>
                    </a-form-item>
                  </a-form>
                </div>
                <!-- 右侧区域 -->
                <div class="config-form-right">
                   <a-form layout="vertical">
                     <a-form-item label="注册自动创建项目和区域">
                       <a-input v-model:value="formState.autoCreateProject" placeholder="" />
                     </a-form-item>
                     <a-form-item>
                        <a-button type="dashed" style="width: 100%">
                          <template #icon><PlusOutlined /></template>
                          新增项目
                        </a-button>
                     </a-form-item>
                   </a-form>
                </div>
              </div>
            </a-tab-pane>
            <a-tab-pane key="app" tab="应用管理">
              <div>应用管理内容区域</div>
            </a-tab-pane>
          </a-tabs>
        </div>
      </div>
    </a-card>
  </div>
</template>

<script setup lang="ts">
import { ref, reactive, watch } from 'vue'
import { useRoute } from 'vue-router'
import SystemSideMenu from '@/components/SystemSideMenu.vue'
import { PlusOutlined } from '@ant-design/icons-vue';

const route = useRoute()
const activeTab = ref('system')

// 表单数据模型
const formState = reactive({
  assignedRole: 'user', // 注册分配的角色
  weatherApiKey: '', // 和风天气秘钥
  feedbackNotifyUser: '', // 问题反馈通知用户
  checkUserLogout: 'allow', // 是否检查用户注销
  enableSSO: 'disable', // 启用单点会话登录
  opLogRetention: 'permanent', // 操作日志保留时间
  loginLogRetention: 'permanent', // 登陆日志保留时间
  autoCreateProject: '', // 注册自动创建项目和区域
})

const saveConfig = () => {
  console.log('Saving config:', formState)
  // 在这里添加保存配置的逻辑
}

// 监听路由确保侧边栏高亮
const selectedKeys = ref(['config'])
const openKeys = ref(['system'])
watch(
  () => route.path,
  (path) => {
    if (path.startsWith('/system/config')) {
      selectedKeys.value = ['config']
      openKeys.value = ['system']
    } else {
      // 根据实际路由结构调整
      selectedKeys.value = [] 
      openKeys.value = []
    }
  },
  { immediate: true }
)

</script>

<style lang="less" scoped>
.config-page {
  padding: 24px;
  background: #f5f7f9;
  min-height: calc(100vh - 112px); // Adjust based on header/footer height
  .config-layout {
    display: flex;
    .side-menu {
      width: 220px;
      background: #fff; // Match image background
      border-radius: 4px;
      margin-right: 16px;
      padding: 16px 0;
      min-height: 600px; // Or adjust as needed
      border: 1px solid #e8e8e8; // Match image border
    }
    .main-content {
      flex: 1;
      background: #fff;
      border-radius: 4px;
      padding: 0 24px 24px 24px; // Adjust padding for tabs
      border: 1px solid #e8e8e8; // Match image border

      :deep(.ant-tabs-nav) {
        margin-bottom: 24px; // Add space below tabs
      }

      .config-content-wrapper {
          display: flex;
          gap: 24px; // Space between left and right forms
      }

      .config-form-left {
          flex: 2; // Adjust ratio as needed
          // Styles for the left form section
      }

      .config-form-right {
          flex: 1; // Adjust ratio as needed
          padding-top: 8px; // Align top content slightly
          // Styles for the right section
          .ant-form-item-label > label {
             font-weight: 500; // Match image label weight
          }
      }
    }
  }
}

// Ensure radio buttons have space
:deep(.ant-radio-group) {
  .ant-radio-wrapper {
    margin-right: 16px;
  }
}

// Adjust form item margin if needed
:deep(.ant-form-item) {
  margin-bottom: 16px;
}
</style>